import React from "react";

/**
 * PageHero — gradient banner for page/section headers.
 * Use inside a px-4 container. Handles ambient lights and shadow-blue.
 */
export default function PageHero({
  title,
  subtitle,
  gradient = "from-[#012e68] via-[#1b4f9c] to-[#2d6cdf]",
  children,
  className = "",
}) {
  return (
    <div
      className={`relative overflow-hidden bg-gradient-to-br ${gradient} text-white rounded-list px-5 py-5 shadow-blue dark:shadow-none ${className}`}
      style={{ WebkitMaskImage: "-webkit-radial-gradient(white, black)" }}
    >
      {/* AMBIENT — single top-right glow */}
      <div className="absolute -top-10 -right-10 h-32 w-32 rounded-full bg-white/10 blur-2xl pointer-events-none" />

      <div className="relative z-10">
        <p className="text-[15px] font-semibold leading-tight">{title}</p>
        {subtitle && <p className="text-[11px] text-white/70 mt-0.5">{subtitle}</p>}
        {children}
      </div>
    </div>
  );
}
